/* global femcare */

/**
 * Main Video Component
 * Handles inline and modal video initialization
 */
femcare.video.init = function () {
    this.$inlineVideos = $('.video-inline');
    this.$modalPlayTriggers = $('.js-play-video-modal');
    this.$allVideoTriggers = this.$inlineVideos.add(this.$modalPlayTriggers);
    this.activePlayers = [];

    const videosExist = this.$allVideoTriggers.length > 0;
    if (videosExist) {
        this.initInlineVideos();
        this.initModalTriggers();
        this.bindGlobalEvents();
    }
};